import { Component } from "react";
import { Container, Form, FormCheck, FormLabel } from "react-bootstrap";

export class ChoiceQuestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: props.value
        }
    }
    
    componentDidUpdate(prevProps, _prevState) {
        if (prevProps !== this.props && this.state.selection !== this.props.value) {
            this.setState({selection: new Set(this.props.value)})
        }
    }
    
    handleRadioChange(idx) {
        const newSet = new Set([idx])
        this.setState({
            selection: newSet
        })
        return newSet;
    }

    handleCheckboxChange(idx, e) {
        const setCopy = new Set(this.state.selection)
        if (e.target.checked) {
            setCopy.add(idx)
        } else {
            setCopy.delete(idx)
        }
        this.setState({
            selection: setCopy
        })
        return setCopy;
    }

    handleChange = idx => (e) => {
        let newSelection;
        if (this.props.questionDetails.questionType == 1) {
            newSelection = this.handleRadioChange(idx);
        } else {
            newSelection = this.handleCheckboxChange(idx, e);
        }
        this.props.propagateAnswer(this.props.idx, Array.from(newSelection));
    }

    render() {
        return (
            <Container>
                <Form>
                    <FormLabel className="mt-3">{this.props.idx + 1}. {this.props.questionDetails.question}</FormLabel>
                    {this.props.questionDetails.answerSet.map((val, idx) => (
                        <FormCheck
                            key={idx}
                            type={this.props.questionDetails.questionType == 1 ? 'radio' : 'checkbox'}
                            name="question-options"
                            className="mx-3 py-2"
                            label={val}
                            onChange={this.handleChange(idx)}
                            checked={this.state.selection?.has?.(idx) ?? false}
                        />
                    ))}
                </Form>
            </Container>
        )
    }
}